import "@/App.css";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { AppShell } from "@/components/AppShell";
import { CoachRegisterPage, LoginPage, RegisterPage, RoleGateway } from "@/pages/AuthPages";
import { AthletesPage, ChecksPage, CoachDashboard, ExercisesPage } from "@/pages/CoachPages";
import { AthletePlanWorkspace, PersonalizedPlansPage } from "@/pages/PersonalizedPlansPage";
import { AthleteDashboard, AthleteHistory } from "@/pages/AthletePages";
import ProfilePage from "@/pages/ProfilePage";
import ChatPage from "@/pages/ChatPage";
import NotificationSettingsPage from "@/pages/NotificationSettingsPage";
import { ForgotPasswordPage, ResetPasswordPage } from "@/pages/PasswordResetPages";
import TemporaryPasswordPage from "@/pages/TemporaryPasswordPage";

function Protected({ role, children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="app-loading" data-testid="auth-loading"><span />CALI HERO</div>;
  if (!user) return <Navigate to={`/login/${role}`} replace />;
  if (user.role !== role) return <Navigate to={user.role === "coach" ? "/coach" : "/athlete"} replace />;
  if (user.role === "athlete" && user.must_change_password) return <Navigate to="/change-temporary-password" replace />;
  return <AppShell>{children}</AppShell>;
}

function PublicOnly({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="app-loading" data-testid="public-auth-loading"><span />CALI HERO</div>;
  if (user) return <Navigate to={user.role === "coach" ? "/coach" : "/athlete"} replace />;
  return children;
}

function App() {
  return <BrowserRouter><AuthProvider><Routes>
    <Route path="/" element={<PublicOnly><RoleGateway /></PublicOnly>} />
    <Route path="/login/:role" element={<PublicOnly><LoginPage /></PublicOnly>} />
    <Route path="/register" element={<PublicOnly><RegisterPage /></PublicOnly>} />
    <Route path="/register/coach" element={<PublicOnly><CoachRegisterPage /></PublicOnly>} />
    <Route path="/forgot-password" element={<PublicOnly><ForgotPasswordPage /></PublicOnly>} />
    <Route path="/reset-password" element={<PublicOnly><ResetPasswordPage /></PublicOnly>} />
    <Route path="/change-temporary-password" element={<TemporaryPasswordPage />} />
    <Route path="/coach" element={<Protected role="coach"><CoachDashboard /></Protected>} />
    <Route path="/coach/athletes" element={<Protected role="coach"><AthletesPage /></Protected>} />
    <Route path="/coach/exercises" element={<Protected role="coach"><ExercisesPage /></Protected>} />
    <Route path="/coach/plans" element={<Protected role="coach"><PersonalizedPlansPage /></Protected>} />
    <Route path="/coach/athletes/:athleteId/plans" element={<Protected role="coach"><AthletePlanWorkspace /></Protected>} />
    <Route path="/coach/checks" element={<Protected role="coach"><ChecksPage /></Protected>} />
    <Route path="/coach/chat" element={<Protected role="coach"><ChatPage /></Protected>} />
    <Route path="/coach/profile" element={<Protected role="coach"><ProfilePage /></Protected>} />
    <Route path="/coach/notifications" element={<Protected role="coach"><NotificationSettingsPage /></Protected>} />
    <Route path="/athlete" element={<Protected role="athlete"><AthleteDashboard /></Protected>} />
    <Route path="/athlete/history" element={<Protected role="athlete"><AthleteHistory /></Protected>} />
    <Route path="/athlete/chat" element={<Protected role="athlete"><ChatPage /></Protected>} />
    <Route path="/athlete/profile" element={<Protected role="athlete"><ProfilePage /></Protected>} />
    <Route path="*" element={<Navigate to="/" replace />} />
  </Routes></AuthProvider></BrowserRouter>;
}

export default App;
